"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "canILiftOff", {
  enumerable: true,
  get: function get() {
    return _canI.canILiftOff;
  }
});
Object.defineProperty(exports, "isElementInViewport", {
  enumerable: true,
  get: function get() {
    return _canI.isElementInViewport;
  }
});
Object.defineProperty(exports, "canIExecuteClientCode", {
  enumerable: true,
  get: function get() {
    return _canI.canIExecuteClientCode;
  }
});

var _canI = require("./canI");